import React from 'react';
import classnames from 'classnames/bind';
import { Typography } from 'gd-design-library';
import { partners } from './partners';

import styles from './PartnersBanner.module.scss';
import Image from 'next/image';

const CN = 'partners-banner';
const containerClassName = `${CN}__container`;
const titleClassName = `${containerClassName}__title`;
const partnerItemsContainerClassName = `${containerClassName}__partner-items-container`;
const partnerItemClassName = `${partnerItemsContainerClassName}__partner-item`;

const cx = classnames.bind(styles);

export const PartnersBanner: React.FC = () => (
  <div className={ cx(CN) }>
    <div className={ cx(containerClassName) }>
      {partners.length > 0 && (
        <>
          <div className={ cx(titleClassName) }>
            <Typography variant='caption' as='span'>In collaboration with:</Typography>
          </div>
          <div className={ cx(partnerItemsContainerClassName) }>
            {partners.map(({ url, logo, partner }) => (
              <div key={ url } className={ cx(partnerItemClassName) }>
                <a href={ url } target='_blank' rel='noreferrer' >
                  <Image src={ logo.src } alt={ partner } width={ 130 } height={ 20 } />
                </a>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  </div>
);
